import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AuthActions, AuthEffects} from '../../store/auth';
import { useLocation } from 'react-router';
import { push } from 'connected-react-router'
import {parseQuery} from "../../util/helper-methods";
import {RootState} from "../../store";
import {Routes} from "../../routes";
import {
  FormCard, FormCardHeader, FormCardTransition, FormCardVariants,
  Line,
  LinkContainer, StyledLink
} from "styles/styled";
import MessageCard from "../../components/message-card";
import {motion} from "framer-motion";
import {defaultMessageObj} from "../../util/constants";
import useDocumentTitle from "../../util/hooks/useDocumentTitle";

const ResetPasswordDisable = () => {

  useDocumentTitle('Reset Password');
  const dispatch = useDispatch();
  const { search } = useLocation();
  const resetKey = useSelector((state: RootState) => state.auth.resetKey);
  const resetPasswordStatus = useSelector((state: RootState) => state.auth.resetPasswordStatus);

  useEffect(() => {
    const newResetKey = parseQuery(search, 'resetKey');
    if(newResetKey && resetKey) {
      dispatch(AuthEffects.disableResetPassword());
      dispatch(push(Routes.RESET_PASSWORD_DISABLE));
    } else if (newResetKey) {
      dispatch(AuthActions.setResetKey(newResetKey));
    } else if(resetKey) {
      dispatch(AuthEffects.disableResetPassword());
    }
  }, [resetKey, search, dispatch]);

  const handleReturnToLogin = () => {
    //this should probably be combined in an effect
    dispatch(AuthActions.clearResetPasswordStatus());
    window.location.assign('/authenticate/login');
  };

  let messageObj = {...defaultMessageObj};
  if(!resetKey) {
    messageObj = {
      message: 'There was no reset token included in your request.',
      type: 'warning'
    }
  } else if(resetPasswordStatus === 'error') {
    messageObj = {
      message: 'An unexpected error occurred invalidating the reset token.',
      type: 'warning'
    }
  } else if(resetPasswordStatus === 'disabled'){
    messageObj = {
      message: 'The password reset token has been successfully invalidated.',
      type: 'success'
    }
  }

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      transition={FormCardTransition}
      variants={FormCardVariants}
    >
      <FormCard>
        <FormCardHeader>Cancel Password Reset</FormCardHeader>
        <Line/>
        <MessageCard type={messageObj.type}>
          {messageObj.message}
        </MessageCard>
      </FormCard>
      <LinkContainer>
        <StyledLink as="a" aria-label="return to login" role='button' onClick={handleReturnToLogin}>Return to login</StyledLink>
      </LinkContainer>
    </motion.div>
  );
};

export default ResetPasswordDisable;
